<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="{ path: 'message.title_delete_object', args: { objectName: deleteObjectTitle } }"></div>
                <hr class="dialog-hr">
                <div class="confirm-body" v-html="$t('message.info_delete_object', { objectName: deleteObjectName })">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('delete')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
      return {
        deleteObjectName: null ,
        deleteObjectTitle: null,
      };
    },
    created: function() {
        this.deleteObjectName = this.confirmInfo.objectName;
        this.deleteObjectTitle = this.confirmInfo.objectTitle;
    },
    props: ['confirmInfo']
}
</script>

<style scoped>


</style>
